import React from 'react'
import { ActivityMonitorIcon, Div, StatusIndicator, StyledChip } from './styles'
import { Box, Tooltip, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import AdminMenuItems from '../AdminMenuItems'
import ReportMenuItems from '../ReportMenuItems'
import AccountDropdown from '../AccountDropdown'
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined'
import ROUTES from '../../../consts/paths'
import { useNavigateToUrl } from '../../../hooks/useNavigateToUrl'
import { env } from '../../../env'
import { useAllowedPath } from '../../../hooks/useAllowedPath'

const TabMenu: React.FC = () => {
  const theme = useTheme()
  const navigateToURL = useNavigateToUrl()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const showActivityMonitor = useAllowedPath(ROUTES.TASKS)
  const environment = env.REACT_APP_AWS_ENVIRONMENT
  const environmentName = env.REACT_APP_AWS_ENVIRONMENT?.split('-')[0]
  const tenant = localStorage.getItem('tenantKey')
  const chipText = `${environmentName}: ${tenant}`
  const showEnvironmentFlag = environment !== 'prod-classranked'

  return (
    <Div isMobile={isMobile}>
      <Box display={'flex'} gap={1}>
        <ReportMenuItems />
        <AdminMenuItems />
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        {showEnvironmentFlag &&
          <StyledChip status={environment} label={
            <Box display='flex' alignItems='center' gap={1}>
              <StatusIndicator status={environment} /> {chipText}
            </Box>
          } />
        }
        {showActivityMonitor &&
          <Tooltip title='Go to Activity Monitor'>
            <ActivityMonitorIcon
              onClick={(e) => { navigateToURL(e, ROUTES.TASKS, true) }}
            >
              {<MonitorHeartOutlinedIcon />}
            </ActivityMonitorIcon>
          </Tooltip>
        }
        <AccountDropdown />
      </Box>
    </Div>
  )
}

export default TabMenu
